const setAllDayClose = (state, payload) => state.dayCloseList = payload;
const setDayClose = (state, payload) => state.dayClose = payload;

export default{
    setAllDayClose,
    setDayClose,
}